import { render, staticRenderFns } from "./CustomizationEditor.vue?vue&type=template&id=4a197500&"
import script from "./CustomizationEditor.vue?vue&type=script&lang=js&"
export * from "./CustomizationEditor.vue?vue&type=script&lang=js&"
import style0 from "./CustomizationEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports